import { CustomerAffiliationMember } from './customer-affiliation-member.model';

export class CustomerAffiliation {
    public id: number;
    public customerNumberID: number;
    public customerAffiliationTypeId: number;
    public customerAffiliationTypeDisplayValue: string;
    public members: CustomerAffiliationMember[];
    public effectiveDate: any;
    public endDate: any;

    public affiliateType: string;
}
